import { formatCurrencyToSend } from ".";

export const checkValue = (values) => {
  if (!Object.values(values).includes("$")) {
    return values;
  } else {
    return formatCurrencyToSend(values);
  }
};
